import React, { Component } from 'react';
import { Translation } from 'react-i18next';

import SmsForm from '../containers/SmsFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class SmsEditScreen extends Component {
  scrollToTop = () => {
    Logger.log('debug', `SmsEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <div>
            <DocumentHead title={t('smses_route_edit')} />
            <SmsForm id={this.props.match.params.id} />
          </div>
        )}
      </Translation>
    );
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default SmsEditScreen;

Logger.log('silly', `SmsEditScreen loaded.`);
